import React from 'react';
import { Route, Navigate } from 'react-router-dom';

import { libraryRoutes } from '../library';
import { adminConfigurationRoutes } from '../admin-configuration';
import { integrationsRoutes } from '../integrations';
import { vulnerabilityManagementRoutes } from '../vulnerability_management';
import { documentAssessmentRoutes } from '../document_assessment';

/**
 * All routes mounted under /athena/*. Composes sub-feature route
 * fragments (library, admin-configuration, integrations, jira/jama,
 * vulnerability-management) so each feature owns its own route
 * definitions instead of having App.jsx know about all of them.
 *
 * FU-001 (2026-05-27): the three workspace-related top-level routes
 * (`attack-trees/:threadId`, `attack-tree/:threadId/:threatId`,
 * `architecture-diagram/editor/:diagramId?`) were retired. AttackTreeList,
 * AttackTreeVisualization, and ArchitectureDiagramPage are now reachable
 * only from inside the project workspace:
 *   /project/:projectId/attack-trees
 *   /project/:projectId/attack-trees/:threatId
 *   /project/:projectId/architecture
 *   /project/:projectId/architecture/:diagramId
 */
export const athenaRoutes = (
  <>
    <Route index element={<Navigate to="/projects" replace />} />
    {libraryRoutes}
    {adminConfigurationRoutes}
    {integrationsRoutes}
    {vulnerabilityManagementRoutes}
    {documentAssessmentRoutes}
  </>
);
